module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": 'mdi-map-marker-off',
      "rules": _vm.clientNameRules,
      "label": "Client"
    },
    model: {
      value: (_vm.clientModel),
      callback: function($$v) {
        _vm.clientModel = $$v
      },
      expression: "clientModel"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-038698d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientAddForm.vue
// module id = 924
// module chunks = 1